<template>
  <div class="home">
    <shell>
      <template v-slot:default>
        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <div>
              <div class="px-2">
                <div class="pb-6">
                  <router-link to="/exports" class="no-underline">Back to Exports</router-link>
                </div>
                <t-text kind="DANGER" v-if="error">{{error}}</t-text>
                <div class="flex justify-between items-baseline">
                  <t-text lvl="1" class="pb-4">
                    <div>

                      <div v-if="type == 'STATIC_SITE'" class="pb-4">
                        <div class="pb-2">Static Site: <span class="font-normal" v-if="params.title">{{params.title}}</span></div>
                        <div class="text-sm">
                          Records in <span class="bg-light-yellow text-xs py-1 px-2 font-bold font-mono">{{params.baseFolder}}</span>
                        </div>

                      </div>
                      <div v-else>
                        <div class="pb-2">Raw Data JSON</div>
                        <div class="text-sm font-bold">All Records</div>
                      </div>
                    </div>
                  </t-text>
                  <div class="text-sm">{{displayDate}}</div>
                </div>
                <div class="text-xl underline font-bold py-2">
                  <a v-if="isComplete && isSuccess" :href="SERVER + '/exports/artifact/' + shortId" download class="cursor-pointer">Download</a>
                  <div v-else-if="isComplete && !isSuccess" class="text-red">Export Failed</div>
                  <div v-else>Generating export...</div>
                </div>
                <div class="flex justify-end items-center">
                  <t-button danger inverted @click="deleteExport">Delete</t-button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>

<script>
 import {DateTime} from 'luxon';
 import {mapState, mapActions} from 'vuex'
 import eventBus from '@/eventBus'
 import api from '@/api'
 import Shell from '@/components/Shell'

 export default {
   name: 'export',
   props: {
     shortId: {
       type: String,
       default: ''
     }
   },
   data () {
     return {
       SERVER: process.env.VUE_APP_API_URL,
       response: '',
       error: '',
       name: '',
       type: '',
       date: '',
       params: null,
       running: false,
       isComplete: false,
       isSuccess: false
     }
   },

   components: { Shell },

   computed: {
     ...mapState({
       member: state => state.member
     }),
     displayDate () {
       return DateTime.fromISO(this.date).toFormat('LLL dd, yyyy')
     },
     displayType () {
       return ({STATIC_SITE: 'Static Site', JSON: 'Raw Data (JSON)'})[this.type]
     }
   },

   async created () {
     const {res: exp, err: expErr} = await api.getExport(this.shortId)

     if (expErr) {
       this.error = expErr.response.data
       this.$router.replace({name: 'exports'})
       return
     }

     this.name = exp.name
     this.params = exp.params
     this.type = exp.type
     this.date = exp.created_at

     this.isComplete = exp.is_complete
     this.isSuccess = exp.is_success
   },

   methods: {
     async deleteExport () {
       if (confirm(`Are you sure you want to delete the ${this.displayType} export created on ${this.displayDate}`)) {
         const {err} = await api.deleteExport(this.shortId)
         if (err) {
           this.error = err.response.data
         } else {
           this.$router.replace({name: 'exports'})
         }
       }
     },
     async download () {

     }
   }
 }
</script>

